import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { Profession } from "./type";

export default function professionDetailButton(props: GridCellParams<Profession, any>) {
    return <Link component={RouterLink} to={props.row.professionCode}>Detay</Link>
}